<glitch-hero mainTitle="MY BLOG" subtitle="Find out more about my experiences as a Software Engineer."></glitch-hero>
